<template>
    <Modal>
        <div class="container-modale">
            <p class="texte center">{{ $t('home.modale.authentication.header') }}</p>
            <div class="center">
                <span>{{ $t('home.modale.authentication.label') }}</span>
            </div>
            <input v-model="email" class="margin-10px width-input" />
            <div class="buttons">
                <Button :onClick="registerMail" :text="$t('home.modale.authentication.button')" class="button" />
            </div>
        </div>
    </Modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Modal from '@/components/ui-components/Modal.vue';
import Button from '@/components/ui-components/Button.vue';
import { loginRequest, msalInstance, useMsalInstance } from '@/authenticationConfig';
import { AUTHENTICATION } from '@/store/mutation-types';
import { AuthenticationResult } from '@azure/msal-browser';
import { store } from '@/plugins/store';
import { AuthenticationParameters } from '@/modules/Auth/store/state';
import ErrorManager from '@/common/utils/ErrorManager';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import { HOME } from '@/modules/Home/store/mutation-types';
import LoginService from '@/modules/Login/services/LoginService';

export default defineComponent({
    name: 'HomePageAuthenticationModale',
    components: { Modal, Button },
    data() {
        return {
            email: '',
        };
    },
    methods: {
        async registerMail(): Promise<void> {
            this.$store.commit(HOME.SET_REGISTER_MAIL_LOADING, true);
            const data: AuthenticationParameters = {
                login: '',
                compteId: store.getters.getUserInformations.t_compte_id,
                password: '',
                mail: this.email,
            };
            await LoginService.registerMail(data)
                .then(async (b2cPolicy: string) => {
                    await useMsalInstance(b2cPolicy);
                    this.seConnecter();
                })
                .catch(async error => {
                    this.$store.commit(`errorToaster/${ERROR.SET_MESSAGE}`, this.$t('error.mail.azure'));
                    await ErrorManager.processErrorCustomMessage(error, this.$t('error.mail.azure'));
                });

            this.$store.commit(HOME.SET_REGISTER_MAIL_LOADING, false);
        },
        seConnecter(): void {
            store.commit(`authenticationState/${AUTHENTICATION.SET_USER_MAIL}`, this.email);
            this.signIn();
        },
        async signIn() {
            // On s'assure que le mode interactif est terminé
            await msalInstance
                .handleRedirectPromise()
                .then((token: AuthenticationResult | null) => {
                    console.info('[Guards] handleRedirectPromise ' + token);
                })
                .catch((error: string) => {
                    console.error(error);
                });

            const request = {
                ...loginRequest,
                loginHint: this.$store.getters['authenticationState/getUserEmail'].toLowerCase(), // Auto-complétion de l'e-mail dans la page Azure
                prompt: 'login', // Auto-complétion de l'e-mail dans la page Azure
            };

            this.$store.commit(`authenticationState/${AUTHENTICATION.SET_SIGN_IN_AZURE_CALLED}`, true);

            // Appel l'étape 1 de la connexion Microsoft
            console.info('[Guards] loginRedirect');
            msalInstance
                .loginRedirect(request)
                .then(() => {
                    console.info('[Guards] loginRedirect OK');
                    // Lorsqu'on est ici la page de connexion Microsoft est affichée, mais on n'est pas connecté,
                    // c'est le guards (acquireTokenSilent() en web, signInByCode() en mobile) qui connectera l'utilisateur dans un second temps
                })
                .catch((error: string) => {
                    console.info('[Guards] loginRedirect KO');
                    console.error(error);
                });
        },
    },
});
</script>

<style scoped>
.container-modale {
    max-width: 50vw;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: var(--white);
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12);
    padding: 30px 30px 15px 30px;
}
.texte {
    margin-top: 1vh;
    margin-bottom: 1vh;
}
.buttons {
    margin-top: 1vh;
    align-self: flex-end;
}
.button {
    margin-left: 1vw;
    background-color: var(--light-green);
    border: 0 solid;
    color: var(--white);
}
.center {
    text-align: center;
}
.width-input {
    width: 40%;
}
.margin-10px {
    margin-top: 10px;
}
@media (max-width: 900px) {
    .width-input {
        width: 70%;
    }
}
</style>
